/* ==========================================================================
   Nova — premium motion layer (anime.js).
   Coherent language across pages: soft fade + rise, easeOutExpo, gentle stagger.
   Respects prefers-reduced-motion. No-ops gracefully if anime.js is absent.
   ========================================================================== */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || typeof anime === 'undefined') return;

  var EASE = 'easeOutExpo';
  var DUR = 820;
  var RISE = 26;

  /* ---------------------- Hero entrance (on load) ---------------------- */
  var heroSeq = document.querySelectorAll('.hero__title, .hero__sub, .hero__cta');
  var product = document.querySelector('.hero__product');
  if (heroSeq.length) {
    anime.set(heroSeq, { opacity: 0, translateY: RISE });
    anime({ targets: heroSeq, opacity: [0, 1], translateY: [RISE, 0],
      delay: anime.stagger(120, { start: 120 }), duration: 900, easing: EASE });
  }
  if (product) {
    anime.set(product, { opacity: 0, translateY: 34, scale: 0.97 });
    anime({ targets: product, opacity: [0, 1], translateY: [34, 0], scale: [0.97, 1],
      duration: 1100, delay: 220, easing: EASE,
      complete: function () {
        anime({ targets: product, translateY: [0, -12], direction: 'alternate',
          loop: true, duration: 3400, easing: 'easeInOutSine' });
      } });
  }

  /* ---------------------- Scroll reveals ---------------------- */
  // Singles: each element rises individually when it scrolls in.
  var singleSel = [
    '.sci__eyebrow', '.sci__heading', '.sci__figure', '.sci__freq', '.sci__play', '.sci__wave',
    '.ben__head', '.ben__statement', '.ben__footnote',
    '.comm-kicker', '.comm-title', '.comm-form', '.comm-subtext', '.comm-logo',
    '.lb-marquee-band__row', '.lp-proof-header',
    '.page-hero__eyebrow', '.page-hero__title', '.page-hero__sub',
    '.contact__form', '.contact__info',
    '.shop-title', '.shop-subtext', '.shop-life', '.shop-banner',
    /* Product page (stable blocks only — never the subs/bundle/qty that the buy-box JS toggles) */
    '.lb-pdp__media', '.lb-pdp__title', '.lb-pdp__price', '.lb-pdp__subline', '.lb-pdp__desc', '.lb-pdp__form', '.lb-pdp__trust',
    /* Custom product sections */
    '.lp-pdp-wrap', '.lp-qty-carousel__inner', '.lp-love-inner', '.lp-compare-section',
    /* Legal / DocuSign page (static header only — the form/iframe/success toggle themselves) */
    '.lpw-legal-eyebrow', '.lpw-legal-title', '.lpw-legal-subtitle', '.lpw-legal-links',
    '[data-reveal]'
  ].join(',');

  // Groups: when the container enters, its children rise with a stagger.
  var groups = [
    ['.feat-grid', '.feat-card'],
    ['.ben__list', '.ben__item'],
    ['.lp-proof-carousel', '.lp-proof-card'],
    ['.faq__list', '.faq__item'],
    ['.shop-products', '.shop-card']
  ];

  var singles = Array.prototype.slice.call(document.querySelectorAll(singleSel));
  if (singles.length) anime.set(singles, { opacity: 0, translateY: RISE });

  groups.forEach(function (g) {
    var kids = document.querySelectorAll(g[0] + ' > ' + g[1]);
    if (kids.length) anime.set(kids, { opacity: 0, translateY: RISE });
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var t = entry.target;
      io.unobserve(t);
      if (t.__group) {
        anime({ targets: t.__group, opacity: [0, 1], translateY: [RISE, 0],
          delay: anime.stagger(90), duration: DUR, easing: EASE });
      } else {
        anime({ targets: t, opacity: [0, 1], translateY: [RISE, 0], duration: DUR, easing: EASE });
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  singles.forEach(function (el) { io.observe(el); });
  groups.forEach(function (g) {
    var c = document.querySelector(g[0]);
    if (c) { c.__group = c.querySelectorAll(':scope > ' + g[1]); io.observe(c); }
  });

  /* ---- Safety net: ON-SCREEN content must never stay hidden ----
     The IntersectionObserver animates reveals as you scroll. This net only force-shows
     elements that are ON SCREEN yet still hidden (throttled rAF / background tab / a failed
     observer). Below-the-fold content is LEFT for the observer so its scroll-reveal still
     plays — that's what keeps the whole page feeling alive. */
  function show(el) {
    if (parseFloat(getComputedStyle(el).opacity) < 0.05) anime.set(el, { opacity: 1, translateY: 0, scale: 1 });
  }
  function allTargets() {
    var list = singles.slice();
    groups.forEach(function (g) { list = list.concat(Array.prototype.slice.call(document.querySelectorAll(g[0] + ' > ' + g[1]))); });
    return list;
  }
  function showOnScreen(list, factor) {
    var vh = window.innerHeight || 800;
    [].forEach.call(list, function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * factor && r.bottom > 0) show(el);
    });
  }
  // Above-the-fold critical content first (anti-FOUC), always shown.
  setTimeout(function () {
    [].forEach.call(document.querySelectorAll('.hero__title, .hero__sub, .hero__cta, .hero__product, .page-hero__eyebrow, .page-hero__title, .page-hero__sub'), show);
  }, 1500);
  // On `load` (images + layout finally settled) reveal anything ON SCREEN still hidden.
  // A fixed timer would fire before images load (page still short) and wrongly reveal
  // below-the-fold blocks; waiting for `load` measures real on-screen positions.
  window.addEventListener('load', function () { showOnScreen(allTargets(), 1); });
  // Deep fallback: if the observer ever fails, scrolling still reveals what's well into
  // view (factor 0.45 → past the observer's trigger, so it never pre-empts an animation).
  var scrollT;
  window.addEventListener('scroll', function () {
    clearTimeout(scrollT);
    scrollT = setTimeout(function () { showOnScreen(allTargets(), 0.5); }, 120);
  }, { passive: true });
})();
